export const sessionReducer = (session = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case "SAVE_TOKEN":
      return {
        ...session,
        token: payload,
      };
    case "SESSION":
      return {
        ...session,
        session: payload,
      };
    default:
      return session;
  }
};
